import SchoolSettings from './SchoolSettings.page';

export default SchoolSettings;
